import { z } from 'zod'

import { GiftCardTopupRecord } from '@/api/rewards/get-gift-card-topups'
import { UserRole } from '@/models/features/user.models'

export const financialsTableFiltersSchema = z.object({
  buildingId: z.coerce.number().optional(),
  fromDate: z.coerce.number().optional(),
  limit: z.coerce.number().optional(),
  search: z.string().optional(),
  skip: z.coerce.number().optional(),
  toDate: z.coerce.number().optional(),
})

export type FinancialsTableFilters = z.infer<typeof financialsTableFiltersSchema>

export type GetColumnsOptions = {
  userRole: UserRole | null
  approvingIds: Set<number>
  decliningIds: Set<number>
  onApprove: (row: GiftCardTopupRecord) => void
  onDecline: (row: GiftCardTopupRecord) => void
}
